import React, { PureComponent } from 'react';
import { Button, Result } from 'antd';
import PropTypes from 'prop-types';


class ErrorBoundary extends PureComponent {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidCatch(error) {
        this.setState({ error });
    }

    // eslint-disable-next-line class-methods-use-this
    handleRefresh() {
        window.location.reload();
    }

    render() {
        const { children } = this.props;
        const { error } = this.state;

        if (error) {
            return (
                <div style={{ height: '100vh', padding: '3em' }}>
                    <Result
                        status="500"
                        title="OOps !"
                        subTitle={(
                            <p>
                                An error has occurred, please reload the page or return to the homepage.<br />
                                Une erreur s&rsquo;est produite, merci de recharger la page ou retourner vers la page d&rsquo;accueil.<br />
                                Er is een fout opgetreden. Laad de pagina opnieuw of ga terug naar de startpagina.
                            </p>
                        )}
                        extra={<Button size="large" onClick={() => this.handleRefresh()}><i className="la la-refresh la-lg" />&nbsp; Refresh</Button>}
                    />
                </div>
            );
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default ErrorBoundary;
